// Single source of truth for ASPRS LAS point classes: the 3D workspace panel, the classify
// editor, and the 2D mosaic classification colormap must all agree on codes, names, and
// colors (see docs/lidar-classification-spec.md). Lives in the ais-api tree because the API
// container only COPYs services/ais-api/src; the frontend re-exports via
// src/core/asprs-classes.js. Colors for 0–18 are Potree's
// ClassificationScheme.DEFAULT normalized to hex for the color picker; 19–22 (LAS 1.4
// extended classes, used by USGS 3DEP deliveries) have no Potree default, so those are ours —
// Temporal Exclusion is deliberately loud (cyan) because it exists mainly for QC review.
export const ASPRS_CLASSES = [
  { id: 0,  name: "Created, Never Classified", color: "#808080" },
  { id: 1,  name: "Unclassified",              color: "#808080" },
  { id: 2,  name: "Ground",                    color: "#333333" },
  { id: 3,  name: "Low Vegetation",            color: "#008000" },
  { id: 4,  name: "Medium Vegetation",         color: "#00cc00" },
  { id: 5,  name: "High Vegetation",           color: "#00ff00" },
  { id: 6,  name: "Building",                  color: "#ffaa00" },
  { id: 7,  name: "Low Point (Noise)",         color: "#ff00ff" },
  { id: 8,  name: "Model Key-Point",           color: "#ff0000" },
  { id: 9,  name: "Water",                     color: "#0000ff" },
  { id: 10, name: "Rail",                      color: "#404040" },
  { id: 11, name: "Road Surface",              color: "#404040" },
  { id: 12, name: "Overlap / Reserved",        color: "#ff0000" },
  { id: 13, name: "Wire Guard",                color: "#ff6600" },
  { id: 14, name: "Wire Conductor",            color: "#ff9900" },
  { id: 15, name: "Transmission Tower",        color: "#cc6600" },
  { id: 16, name: "Wire-Structure Connector",  color: "#996600" },
  { id: 17, name: "Bridge Deck",               color: "#808080" },
  { id: 18, name: "High Noise",                color: "#ff0000" },
  { id: 19, name: "Overhead Structure",        color: "#cc9933" },
  { id: 20, name: "Ignored Ground",            color: "#666633" },
  { id: 21, name: "Snow",                      color: "#ffffff" },
  { id: 22, name: "Temporal Exclusion",        color: "#00ffff" },
];

export function asprsClassName(code) {
  return ASPRS_CLASSES.find((c) => c.id === Number(code))?.name || "Unknown";
}

export function classDefaultColor(id) {
  return ASPRS_CLASSES.find((c) => c.id === Number(id))?.color || "#808080";
}
